import React, { FunctionComponent } from 'react';
import { HideContentWithLoaderStyles as S } from './HideContentWithLoader.styles';

export interface HideContentWithLoaderProps {
  hide?: boolean;
}

/**
 * Hides the children but reserves space and shows a centered spinner when `hide` is true.
 */
const HideContentWithLoader: FunctionComponent<HideContentWithLoaderProps> = ({ hide = false, children }) => (
  <S.Wrapper>
    <S.Hider hide={hide}>{children}</S.Hider>
  </S.Wrapper>
);

export default HideContentWithLoader;
